const rules = {
	user: {
		static: [],
	},

	// Supervisor: same as user but can see ALL agents' conversations.
	// No access to admin settings, connections, or system configuration.
	supervisor: {
		static: [
			"tickets-manager:showall",
		],
	},

	admin: {
		static: [
			//"dashboard:view",
			"drawer-admin-items:view",
			"tickets-manager:showall",
			"user-modal:editProfile",
			"user-modal:editQueues",
			"ticket-options:deleteTicket",
			"ticket-options:scheduleAppointment",
			"contacts-page:deleteContact",
			"connections-page:actionButtons",
			"connections-page:addConnection",
			"connections-page:editOrDeleteConnection"
		],
	},
};

export default rules;
